import { useEffect } from 'react';
import { seo } from '../data/seo';
import { contact } from '../data/contact';
import { awards, references } from '../data/recognition';
const FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="30" fill="#0E1A2B" stroke="#B8923F" stroke-width="3"/><text x="32" y="41" text-anchor="middle" font-family="Georgia, serif" font-size="24" font-weight="700" fill="#B8923F">JG</text></svg>`;
const FAVICON_HREF = `data:image/svg+xml,${encodeURIComponent(FAVICON_SVG)}`;
const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [{
    '@type': 'WebSite',
    '@id': `${seo.siteUrl}#website`,
    url: seo.siteUrl,
    name: seo.siteName,
    description: seo.description,
    inLanguage: 'en-GB',
    about: {
      '@id': `${seo.siteUrl}#person`
    }
  }, {
    '@type': 'ProfilePage',
    '@id': `${seo.siteUrl}#profile`,
    url: seo.siteUrl,
    name: seo.title,
    isPartOf: {
      '@id': `${seo.siteUrl}#website`
    },
    mainEntity: {
      '@id': `${seo.siteUrl}#person`
    }
  }, {
    '@type': 'Person',
    '@id': `${seo.siteUrl}#person`,
    name: 'Jim Godfrey',
    alternateName: ['James Eric Godfrey', 'James “Jim” Godfrey OBE'],
    honorificSuffix: 'OBE',
    jobTitle: 'Non-Executive Director & Board Chair',
    description: seo.description,
    url: seo.siteUrl,
    image: seo.image,
    email: `mailto:${contact.email}`,
    telephone: '+447860581780',
    address: {
      '@type': 'PostalAddress',
      addressRegion: 'North Lincolnshire',
      addressCountry: 'GB'
    },
    alumniOf: {
      '@type': 'CollegeOrUniversity',
      name: 'University of Reading'
    },
    award: awards.map(a => `${a.title} (${a.year})`),
    sameAs: references.map(r => r.url)
  }]
};
function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function upsertLink(rel: string, href: string, type?: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
  if (type) el.setAttribute('type', type);
}
export function SiteMeta() {
  useEffect(() => {
    document.documentElement.lang = 'en-GB';
    document.title = seo.title;
    upsertMeta('name', 'description', seo.description);
    upsertMeta('name', 'author', 'Jim Godfrey');
    upsertMeta('name', 'robots', 'index, follow, max-image-preview:large');
    upsertMeta('name', 'theme-color', seo.themeColor);
    upsertMeta('name', 'application-name', seo.siteName);
    upsertMeta('name', 'apple-mobile-web-app-title', seo.siteName);
    upsertMeta('property', 'og:type', 'profile');
    upsertMeta('property', 'og:site_name', seo.siteName);
    upsertMeta('property', 'og:title', seo.title);
    upsertMeta('property', 'og:description', seo.description);
    upsertMeta('property', 'og:url', seo.siteUrl);
    upsertMeta('property', 'og:locale', seo.locale);
    upsertMeta('property', 'og:image', seo.image);
    upsertMeta('property', 'og:image:alt', seo.imageAlt);
    upsertMeta('property', 'profile:first_name', 'Jim');
    upsertMeta('property', 'profile:last_name', 'Godfrey');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', seo.title);
    upsertMeta('name', 'twitter:description', seo.description);
    upsertMeta('name', 'twitter:image', seo.image);
    upsertMeta('name', 'twitter:image:alt', seo.imageAlt);
    upsertLink('canonical', seo.siteUrl);
    document.head.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach(el => el.remove());
    upsertLink('icon', FAVICON_HREF, 'image/svg+xml');
    upsertLink('apple-touch-icon', FAVICON_HREF);
    let ld = document.head.querySelector<HTMLScriptElement>('script#jim-godfrey-ld');
    if (!ld) {
      ld = document.createElement('script');
      ld.id = 'jim-godfrey-ld';
      ld.type = 'application/ld+json';
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(structuredData);
  }, []);
  return null;
}